/**
 * @packageDocumentation
 * Implements the prize chart button and popup, listing available payouts and legend information for the current game.
 */
import * as PIXI from "pixi.js";
import { Assets } from "pixi.js";
import { brightnessFilter, dullFilter2, font_main, font_third, HandleOrientation } from "./global";
import { gsap } from "gsap";
import { SoundManager } from "./sounds";
import { EnumEventBus, EventBus } from "../EventBus";
import addInteraction from "../lib/addButtonInteraction";
import { Spine } from "@esotericsoftware/spine-pixi-v8";
/*
 * Class representing the PrizeChart area UI component
 * @extends PIXI.Container
 */

const getCharacterPayouts = (amount: number):string[][] => Array(5).fill(
  [`At least 1 civilian card - $${amount * 4}`, `3 matching superhero cards - $${amount * 50}`]
)

const getBorderPayouts = (amount: number) => [
  [`3 matching borders - $${amount * 2}`],
  [`3 matching borders - $${amount * 3}`],
  [`3 matching borders - $${amount * 5}`],
  [`3 matching borders - $${amount * 8}`]
]

type StageType = PIXI.ContainerChild&{backup_visible?:boolean}
let visibleElements:PIXI.ContainerChild[] = []
export class PrizeChartButton extends PIXI.Container {
  PrizeChartContainer: any;
  PrizeChartValueText: PIXI.Text;
  prizePopup!: PrizeChartPopup;
  
  constructor(app:PIXI.Application) {
    super();
    this.PrizeChartContainer = new PIXI.Container();
    
    // Background for the PrizeChartButton
    let PrizeChartBg = new PIXI.Sprite(Assets.get("How_to_play_but"));
    PrizeChartBg.anchor.set(0.5);
    PrizeChartBg.scale.set(0.75);
    // Text for the button
    this.PrizeChartValueText = new PIXI.Text();
    this.PrizeChartValueText.text = "PRIZE CHART";
    this.PrizeChartValueText.style = {
      fontFamily: font_main,
      align: "center",
      fill: "white",
      fontSize: 23,
      fontWeight: "lighter",
      dropShadow: {
        alpha: 0.8,
        angle: 1,
        blur: 4,
        color: "0x111111",
        distance: 2,
      },
      stroke: {
        color: "black",
        width: 2,
        join: "round",
      },
      // letterSpacing: 2,
    };
    this.PrizeChartValueText.anchor.set(0.5);
    this.PrizeChartValueText.x = 30;
    this.PrizeChartValueText.y = 2;
    this.PrizeChartValueText.anchor.set(0.5);
    this.PrizeChartContainer.addChild(PrizeChartBg, this.PrizeChartValueText);
    
    // Add the container to the display list
    this.addChild(this.PrizeChartContainer);

    const handleTapFunc = () => {
      SoundManager.Btnclick_1SndPlay();
      
      visibleElements = [];
      (app.stage.children).forEach((element)=>{ 
        if(element.visible){
          visibleElements.push(element) 
        }
        element.visible = false
      })
      this.prizePopup.visible=true
    }
    
    addInteraction(this.PrizeChartContainer, handleTapFunc, false);
  }
}

// Popup class for the prize chart carousel
// class PrizeChartPopup extends PIXI.Container {
 export class PrizeChartPopup extends PIXI.Container {
  private characterPayoutsTexts: PIXI.Text[][] = [];
  private borderPayoutsTexts: PIXI.Text[] = [];
  imageCombinations: string[][];  // Original image combinations
  currentCombinationIndex: number;

  newImageCombinations: string[][];  // New image combinations
  currentNewCombinationIndex: number;
  // app!: PIXI.Application;
  popupContainer: PIXI.Container;
  imageHoldersContainer!: PIXI.Container;
  newImageHoldersContainer!: PIXI.Container;

  imageHolder!: PIXI.Container;    // Superhero (Original)
  imageHolder2!: PIXI.Container;   // Left Civilian (Original)
  imageHolder3!: PIXI.Container;   // Right Civilian (Original)
  
  newImageHolder!: PIXI.Container;     // New Superhero
  newImageHolder2!: PIXI.Container;    // New Left Civilian
  newImageHolder3!: PIXI.Container;    // New Right Civilian
  // closeButton!: PIXI.Sprite;
  combinationContainers: PIXI.Container<PIXI.ContainerChild>[] = [];
  combinationContainersnext: PIXI.Container<PIXI.ContainerChild>[] = [];
  isArrowDisable = false;
  isArrowDisable_new = false;

  CharectorsTweens:gsap.core.Tween[] = []
  BordersTweens:gsap.core.Tween[] = []
  app: PIXI.Application<PIXI.Renderer>;
  popupBg!:PIXI.Sprite
  titleText!:PIXI.Text;
  newTitleText!:PIXI.Text; 
  missionText!:PIXI.Text;
  closeButton!:PIXI.Container;
  constructor(app:PIXI.Application) {
    super();
    this.app = app; 
    this.popupContainer = new PIXI.Container();
    this.imageHoldersContainer = new PIXI.Container();
    this.newImageHoldersContainer = new PIXI.Container();

    this.addChild(this.popupContainer);
    this.visible=false
    this.popupContainer.x=1000
    this.popupContainer.y=61.5
    this.popupContainer.scale.set(1);
    // Background
    const popupBg = new PIXI.Sprite(Assets.get("prizechart_popup"));
    popupBg.anchor.set(0.5);
    popupBg.scale.set(0.67);
    popupBg.x = -312;
    popupBg.y = 303;
    this.popupBg = popupBg
    this.popupContainer.addChild(popupBg);
    this.combinationContainers = [];
    this.combinationContainersnext = []
    // Original Image Combinations
    this.imageCombinations = [
      ["Green_civilian", "Green_civilian", "Green_superhero"],
      ["Purple_civilian", "Purple_civilian", "Purple_superhero"],
      ["Red_civilian", "Red_civilian", "Red_superhero"],
      ["Yellow_civilian", "Yellow_civilian", "Yellow_superhero"],
      ["Blue_civilian", "Blue_civilian", "Blue_superhero"],
    ];
    this.currentCombinationIndex = 0;
    for(let i=0;i<5;i++){
        const combo = this.imageCombinations[i];

      const ind_payConatainer=new PIXI.Container()
      ind_payConatainer.x=-598
      // ind_payConatainer.x= 0
        this.setupOriginalImages(ind_payConatainer,combo, getCharacterPayouts(2)[i]);  // Initialize original images and arrows
        this.imageHoldersContainer.addChild(ind_payConatainer)
        this.combinationContainers.push(ind_payConatainer)
    }

    this.imageHoldersContainer.x=-598
    const shape = new PIXI.Graphics()
      .rect(0, 0, 470,501)
      .fill("black"); // Hex color (blue)

    shape.alpha=0.7
    shape.x = -240
    shape.y = 79
    this.imageHoldersContainer.addChild(shape); // if inside a PIXI.Container subclass
    this.imageHoldersContainer.mask = shape; 
    this.popupContainer.addChild(this.imageHoldersContainer)
    // New Image Combinations
    this.newImageCombinations = [
      ["gold", "gold", "gold"], 
      ["silver", "silver", "silver"],
      ["bronze", "bronze", "bronze"],
      ["halo", "halo", "halo"],
    ];
    this.currentNewCombinationIndex = 0;
    for(let i = 0; i < 4; i++){
        const newCombo = this.newImageCombinations[i];

        const inde_payConatainer = new PIXI.Container()
          inde_payConatainer.x =- 598
 
        this.setupNewImages(inde_payConatainer,newCombo, getBorderPayouts(2)[i]);  // Initialize original images and arrows
        this.newImageHoldersContainer.addChild(inde_payConatainer)
        this.combinationContainersnext.push(inde_payConatainer)
    }
    // this.newImageHoldersContainer.x=267
    const shapes = new PIXI.Graphics()
      .rect(0, 0, 453.5,501)
      .fill("black") // Hex color (blue)
    shapes.alpha=0.7
    shapes.x = -247
    shapes.y = 79
    this.newImageHoldersContainer.addChild(shapes); // if inside a PIXI.Container subclass
    this.newImageHoldersContainer.mask = shapes; 
    this.popupContainer.addChild(this.newImageHoldersContainer)

    // this.setupNewImages(); 
    this.create_arrow() // Initialize new images and arrows
    this.closebuttons()
    this.anotherarrow()
    // Title Text
    const titleText = new PIXI.Text("PRIZE CHART", {
      fontFamily: font_main,
      fontSize: 24,
      fill: "white",
      align: "center",
    });
    titleText.anchor.set(0.5);
    titleText.y = -150;
    // titleText.
    this.titleText = titleText;
    // this.popupContainer.addChild(titleText);
    this.changeCombination("right")
    this.changeNewCombination("right")
    HandleOrientation(this.PortraitAdjustFun.bind(this),this.landScapeAdjustFun.bind(this))
    EventBus.on(EnumEventBus.setPlayAmount, (v: number) => this.updatePrizeTexts(v));
  }
  updatePrizeTexts(v: number) {
    const characterPayouts =  getCharacterPayouts(v);
    const borderPayouts = getBorderPayouts(v);

    this.characterPayoutsTexts.forEach((ts, tsI) => ts.forEach((t,tI) => t.text = characterPayouts[tsI][tI]));
    this.borderPayoutsTexts.forEach((b, bI) => b.text = borderPayouts[bI]);
  }
  // Setup Original Images and Arrows
    // Setup New Images and Arrows
  genImageHolder(coord:{x: number, y: number}, rot: number, cardAssets: string, borderAssets: string |  { skeleton: string, atlas: string } = "frameOuter", showCard: boolean) {
    const holder = new PIXI.Container();
    const card = holder.addChild(new PIXI.Sprite(Assets.get(cardAssets)));
    card.anchor.set(.5);
    card.filters = [showCard ? brightnessFilter: dullFilter2];

    if(borderAssets) {
      let border;
      if(typeof borderAssets == "string") {
        border = new PIXI.Sprite(Assets.get(borderAssets))
        border.anchor.set(.5);
      } else {
        border = Spine.from({
          skeleton: borderAssets.skeleton,
          atlas: borderAssets.atlas,
        });
        border.state.setAnimation(0, "static", true);
        border.state.timeScale = 0.8;
      }
      border.y = -6;
      border.filters = [showCard ? dullFilter2: brightnessFilter];
      holder.addChild(border);
    }
    holder.position.copyFrom(coord);
    holder.rotation = rot;
    holder.scale.set(0.5);
    return holder; 
  }
  setupNewImages(parent:PIXI.Container,newCombo:string[],values:string[]) {
    // const newCombo = this.newImageCombinations[this.currentNewCombinationIndex];
    const newimages_container = new PIXI.Container();
    const newtexts_container = new PIXI.Container();
    // this.newImageHoldersContainer = new PIXI.Container();
  const cardPairs = { 
   gold: { skeleton: "Gold_frame_anim_json", atlas: "Gold_frame_anim_atlas" },
   silver: { skeleton: "Silver_frame_anim_json", atlas: "Silver_frame_anim_atlas" },
   bronze: { skeleton: "bronze_frame_anim_json", atlas: "bronze_frame_anim_atlas" },
   halo: { skeleton: "Hologram_frame_anim_json", atlas: "Hologram_frame_anim_atlas" },
  };
  //@ts-ignore
    this.newImageHolder2 = this.genImageHolder({x: -94, y: 272}, -.2, "civilian_wild_card", cardPairs[newCombo[0]], false); // Left Civilian (Behind Left)
  //@ts-ignore
    this.newImageHolder3 = this.genImageHolder({x: 82, y: 272}, .2, "civilian_wild_card", cardPairs[newCombo[0]], false); // Right Civilian (Behind Right)
  //@ts-ignore
    this.newImageHolder = this.genImageHolder({x: 0, y: 266}, 0, "hero_wild_card", cardPairs[newCombo[0]], false); // Center Superhero (Front)
    newimages_container.addChild(this.newImageHolder2, this.newImageHolder3, this.newImageHolder);
    parent.addChild(newimages_container);
  
    const textStyle = new PIXI.TextStyle({
      fontFamily: font_main,
      fontSize: 28,
      fill: "white",
      fontWeight: "bold",
      align: "left",
      stroke: "#000000",       // black outline for contrast (optional)
      // strokeThickness: 3,
    });

// List of values you want to display
// const values = ["Value 1", "Value 2", "Value 3"];

    values.forEach((value, index) => {
      const text = new PIXI.Text(value, textStyle);
      text.anchor.set(0.5)
      //text.x = -280 // left aligned in container
      text.y = 470 + index * 40; // 40px vertical spacing
      newtexts_container.addChild(text);
      this.borderPayoutsTexts.push(text);
    });   
    parent.addChild(newtexts_container);
  }
  setupOriginalImages(parent:PIXI.Container,combo:string[], anotherValues:string[]) {
    const images_container = new PIXI.Container();
    const texts_container = new PIXI.Container(); 
    // Left Civilian (Behind Left)
    this.imageHolder2 = this.genImageHolder({x: -94, y: 272}, -.2, combo[0], "frameOuter", true);
    this.imageHolder3 = this.genImageHolder({x: 82, y: 272}, .2, combo[1], "frameOuter", true);
    this.imageHolder = this.genImageHolder({x: 0, y: 266}, 0, combo[2], "frameOuter", true);

    images_container.addChild(this.imageHolder2, this.imageHolder3, this.imageHolder);
    parent.addChild(images_container);
    
// this.combinationContainers.push(this.imageHoldersContainer);
    // this.imageHoldersContainer.x = -318;
    // this.imageHoldersContainer.y = -15;
  const anotherTextStyle = new PIXI.TextStyle({
  fontFamily: font_main,
  fontSize: 28,
  fill: "white",
  fontWeight: "bold",
  align: "left",
  stroke: "#000000",
  // strokeThickness: 3,
});

// List of values for the second set
// const anotherValues = ["Value 1", "Value 2"];
let textArr: PIXI.Text[] = [];
anotherValues.forEach((val, idx) => {

  const anotherText = new PIXI.Text(val, anotherTextStyle);
  anotherText.anchor.set(0.5)
  // anotherText.x = 240;               // same x position, or adjust if needed
  anotherText.y = 450 + idx * 40;     // vertical spacing
  // this.imageHoldersContainer.addChild(anotherText);
    texts_container.addChild(anotherText);
    textArr.push(anotherText);
});

  this.characterPayoutsTexts.push(textArr);
    parent.addChild(texts_container);
    
  }
  genArrow(coord: {x: number, y: number}, assets:string, onHandleTapFunc: () => void, isLeft: boolean = false) {
    const arrowCon = new PIXI.Container();
    const arrow = arrowCon.addChild(new PIXI.Sprite(Assets.get(assets)));
    arrow.anchor.set(0.5);
    arrowCon.position.copyFrom(coord);
    arrowCon.scale.set(isLeft ? -.67 : .67, .67)
    addInteraction(arrowCon, onHandleTapFunc, true);
    return arrowCon;
  }
  create_arrow(){
    // Left Arrow for Original Set
    const leftArrow = this.genArrow({x: -845, y:266}, "arrow_right", () => this.changeCombination("left"), true);
    const rightArrow = this.genArrow({x: -360, y: 266}, "arrow_right", () => this.changeCombination("right"), false);
    this.popupContainer.addChild(leftArrow, rightArrow);
  }


  anotherarrow(){
     // New Left Arrow
    const leftArrow = this.genArrow({x: -256, y: 266}, "arrow_right", () => this.changeNewCombination("left"), true);
    const rightArrow = this.genArrow({x: 217, y: 266}, "arrow_right", () => this.changeNewCombination("right"), false)
    this.popupContainer.addChild(leftArrow, rightArrow);
  }
  closebuttons(){
  const closeButton = new PIXI.Sprite(Assets.get("but_autocount"));
    closeButton.anchor.set(0.5);
    closeButton.scale.set(0.7);
    closeButton.x = 167 // Adjust based on your popup size
    closeButton.y = 6  // Adjust based on your popup size
    closeButton.interactive = true;
    closeButton.cursor = "pointer"
    // closeButton.on("pointerdown", () => this.closePopup());
      closeButton.on("pointertap", () => this.closePopup()); 
      closeButton.on("pointerover",()=>{
        closeButton.filters = [brightnessFilter]
      })
      closeButton.on("pointerout",()=>{
        closeButton.filters = []
      })  
      closeButton.on("pointerdown",()=>{
        closeButton.scale.set(0.65); 
      })
      closeButton.on("pointerup",()=>{
        closeButton.scale.set(0.7); 
      })    
      closeButton.on("pointerupoutside",()=>{
        closeButton.scale.set(0.7); 
      })   
      this.closeButton = closeButton;




    this.popupContainer.addChild(closeButton);

    const closeButtonText = new PIXI.Text("GO BACK", {
      fontFamily: font_main,
      align: "center",
      fill: "white",
      fontSize: 40,
      fontWeight: "lighter",
      dropShadow: {
        alpha: 0.8,
        angle: 1,
        blur: 4,
        color: "0x111111",
        distance: 2,
      },
      stroke: {
        color: "black",
        width: 2,
        join: "round",
      },
      // letterSpacing: 2,
    });
closeButtonText.anchor.set(0.5); 

// Add text to the popup container (on top of the button)
closeButton.addChild(closeButtonText);

    // Title Text for New Set
    const newTitleText = new PIXI.Text();
    newTitleText.text = "Win By Matching the Character Or Border!";
    newTitleText.style = {
      fontFamily: font_third,
      fontWeight:"lighter",
      fontSize: 32,
      fill: "white",
      align: "center",
      letterSpacing:3
    }
    newTitleText.anchor.set(0.5);
    newTitleText.y = 0
    newTitleText.x = -360
    this.newTitleText = newTitleText;
    this.popupContainer.addChild(newTitleText);
    const missionText = new PIXI.Text("Any 3 Superheroes unlock the Bonus Mission!", {
  fontFamily: font_third,
 fontWeight:"lighter",
 fontSize: 30,  // You can adjust the font size as needed
  fill: "white",  // Text color
  align: "center",
      letterSpacing:3

  // stroke: "#FFFF00", // Yellow border (for stroke)
  // strokeThickness: 4  // You can adjust stroke thickness if needed
});
missionText.anchor.set(0.5);
missionText.x = -360
missionText.y =620;  // Adjust vertical positioning as needed
this.missionText = missionText;
this.popupContainer.addChild(missionText);
  }

  changeCombination(direction: string) {
    // if(this.isArrowDisable)return
            SoundManager.Btnclick_1SndPlay();

    if(this.isArrowDisable){
      this.CharectorsTweens.forEach(tween=>tween.progress(1))
    }    
    this.isArrowDisable = true
    const oldIndex = this.currentCombinationIndex;
    let newIndex = direction === "right" ? oldIndex + 1 : oldIndex - 1;

    // Wrap around
    if (newIndex >= this.combinationContainers.length) {
      newIndex = 0;
    } else if (newIndex < 0) {
      newIndex = this.combinationContainers.length - 1;
    }

    // No change
    if (newIndex === oldIndex) return;

    const oldContainer = this.combinationContainers[oldIndex];
    const newContainer = this.combinationContainers[newIndex];

    const offset =598;
    const dir = direction === "right" ? 1 : -1;

    // Start position of the new container (off-screen)
    newContainer.x = -offset * dir;
    newContainer.visible = true;

    // Animate both containers
   const tween1 =  gsap.to(oldContainer, {
      x: offset * dir,
      duration: 0.5,
      ease: "power4.out",
      onComplete: () => {
        oldContainer.visible = false;
        oldContainer.x = 0;
        this.isArrowDisable = false

      }
    });
// BordersTweens
   const tween2 =  gsap.to(newContainer, {
      x:0,
      duration: 0.5,
      ease: "power4.out",
      onComplete: () => {
        this.currentCombinationIndex = newIndex;
      }
    });
    this.CharectorsTweens.push(tween1,tween2)
  }
 
  // Change combo (new)
  changeNewCombination(direction: string) {
    if(this.isArrowDisable_new){
      this.BordersTweens.forEach(tween=>tween.progress(1))
    }
    this.isArrowDisable_new = true
            SoundManager.Btnclick_1SndPlay();

     const oldIndex = this.currentNewCombinationIndex;
    let newIndex = direction === "right" ? oldIndex + 1 : oldIndex - 1;
  // Wrap around
  if (newIndex >= this.combinationContainersnext.length) {
    newIndex = 0;
  } else if (newIndex < 0) {
    newIndex = this.combinationContainersnext.length - 1;
  }

  // No change
  if (newIndex === oldIndex) return;

  const oldsContainer = this.combinationContainersnext[oldIndex];
  const newsContainer = this.combinationContainersnext[newIndex];

  const offset =598;
  const dir = direction === "right" ? 1 : -1;

  // Start position of the new container (off-screen)
  newsContainer.x = -offset * dir;
  newsContainer.visible = true;


  // Animate both containers
  const tween1 = gsap.to(oldsContainer, {
    x: offset * dir,
    duration: 0.5,
    ease: "power4.out",
    onComplete: () => {
      oldsContainer.visible = false;
      oldsContainer.x = 0;
      this.isArrowDisable_new = false

    }
  });

  const tween2 = gsap.to(newsContainer, {
    x:0,
    duration: 0.5,
    ease: "power4.out",
    onComplete: () => {
      this.currentNewCombinationIndex = newIndex;
    }
  });
  this.BordersTweens.push(tween1,tween2)
  }

 
  // Optional: Hide popup
  closePopup() {
            SoundManager.Btnclick_1SndPlay();

    console.log(this.visible,"close popup")
    // this.app.stage.children.forEach(element=>element.visible = true)
          visibleElements.forEach(element=>element.visible=true)

    // setTimeout(() => { 
      this.visible=false
    // }, 10);
    // this.destroy({ children: true, texture: false });
  }
  PortraitAdjustFun(){
    this.scale.set(0.445)
    this.position.set(374.5,223) 
    this.popupBg.scale.set(1);
    this.popupBg.x = -312;
    this.popupBg.y = 278;
 
    this.titleText.style.fontSize = 40;
    this.titleText.y = -150; 

    this.newTitleText.style.fontSize = 40; 
    this.newTitleText.x = -338.5
    this.newTitleText.y = -168
    this.newTitleText.style.wordWrap = true;
    this.newTitleText.style.wordWrapWidth = 820.5;

    this.missionText.style.fontSize = 40;  
    this.missionText.x = -360;
    this.missionText.y = 749.5;
   
    this.closeButton.scale.set(0.7);
    this.closeButton.x = 167 // Adjust based on your popup size
    this.closeButton.y = -183  // Adjust based on your popup size
  }  
  landScapeAdjustFun(){
    this.scale.set(1)
    this.position.set(0)
    this.popupBg.scale.set(0.67);
    this.popupBg.x = -312;
    this.popupBg.y = 303;
 
    this.titleText.style.fontSize = 24;
    this.titleText.y = -150; 

    this.newTitleText.style.fontSize = 32; 
    this.newTitleText.y = 0
    this.newTitleText.x = -360

    this.missionText.style.fontSize = 30; 
    this.missionText.x = -360
    this.missionText.y =620;
   
    this.closeButton.scale.set(0.7);
    this.closeButton.x = 167 // Adjust based on your popup size
    this.closeButton.y = 6  // Adjust based on your popup size
  }  
}